/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { EIfapmeSide } from './EIfapmeSide';
import {
    EIfapmeSideFromJSON,
    EIfapmeSideFromJSONTyped,
    EIfapmeSideToJSON,
} from './EIfapmeSide';
import type { EStatutDemandeListSearch } from './EStatutDemandeListSearch';
import {
    EStatutDemandeListSearchFromJSON,
    EStatutDemandeListSearchFromJSONTyped,
    EStatutDemandeListSearchToJSON,
} from './EStatutDemandeListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface DashboardInscriptionSearch
 */
export interface DashboardInscriptionSearch {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardInscriptionSearch
     */
    apprenant?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardInscriptionSearch
     */
    formation?: UnaccentTextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardInscriptionSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardInscriptionSearch
     */
    typeCours?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardInscriptionSearch
     */
    degre?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardInscriptionSearch
     */
    metier?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardInscriptionSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardInscriptionSearch
     */
    type?: TextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardInscriptionSearch
     */
    envoyeur?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardInscriptionSearch
     */
    encodeur?: UnaccentTextSearch;
    /**
     * 
     * @type {EStatutDemandeListSearch}
     * @memberof DashboardInscriptionSearch
     */
    codeStatut?: EStatutDemandeListSearch;
    /**
     * 
     * @type {EIfapmeSide}
     * @memberof DashboardInscriptionSearch
     */
    ifapmeSide?: EIfapmeSide;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardInscriptionSearch
     */
    onlyUserDashboard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardInscriptionSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardInscriptionSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardInscriptionSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardInscriptionSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardInscriptionSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardInscriptionSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardInscriptionSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardInscriptionSearch interface.
 */
export function instanceOfDashboardInscriptionSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardInscriptionSearchFromJSON(json: any): DashboardInscriptionSearch {
    return DashboardInscriptionSearchFromJSONTyped(json, false);
}

export function DashboardInscriptionSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardInscriptionSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apprenant': !exists(json, 'apprenant') ? undefined : UnaccentTextSearchFromJSON(json['apprenant']),
        'formation': !exists(json, 'formation') ? undefined : UnaccentTextSearchFromJSON(json['formation']),
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'typeCours': !exists(json, 'typeCours') ? undefined : TextSearchFromJSON(json['typeCours']),
        'degre': !exists(json, 'degre') ? undefined : TextSearchFromJSON(json['degre']),
        'metier': !exists(json, 'metier') ? undefined : TextSearchFromJSON(json['metier']),
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'type': !exists(json, 'type') ? undefined : TextSearchFromJSON(json['type']),
        'envoyeur': !exists(json, 'envoyeur') ? undefined : UnaccentTextSearchFromJSON(json['envoyeur']),
        'encodeur': !exists(json, 'encodeur') ? undefined : UnaccentTextSearchFromJSON(json['encodeur']),
        'codeStatut': !exists(json, 'codeStatut') ? undefined : EStatutDemandeListSearchFromJSON(json['codeStatut']),
        'ifapmeSide': !exists(json, 'ifapmeSide') ? undefined : EIfapmeSideFromJSON(json['ifapmeSide']),
        'onlyUserDashboard': !exists(json, 'onlyUserDashboard') ? undefined : json['onlyUserDashboard'],
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardInscriptionSearchToJSON(value?: DashboardInscriptionSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apprenant': UnaccentTextSearchToJSON(value.apprenant),
        'formation': UnaccentTextSearchToJSON(value.formation),
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'typeCours': TextSearchToJSON(value.typeCours),
        'degre': TextSearchToJSON(value.degre),
        'metier': TextSearchToJSON(value.metier),
        'centre': TextSearchToJSON(value.centre),
        'type': TextSearchToJSON(value.type),
        'envoyeur': UnaccentTextSearchToJSON(value.envoyeur),
        'encodeur': UnaccentTextSearchToJSON(value.encodeur),
        'codeStatut': EStatutDemandeListSearchToJSON(value.codeStatut),
        'ifapmeSide': EIfapmeSideToJSON(value.ifapmeSide),
        'onlyUserDashboard': value.onlyUserDashboard,
        'hideMasquees': value.hideMasquees,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

